import React,{ Component } from 'react';

// import PropTypes from 'prop-types';


import TableCell from '@mui/material/TableCell';
//import {grey} from '@mui/material/colors';

const s:any = {
  headercell:{
    backgroundColor: 'grey.shade200', // grey['600'], //theme.palette.common.purple,
    color: 'secondary.light',
    // borderRightStyle: 'solid',
    // borderRightColor: 'grey['500']', //.light,
    // borderRightWidth: '1px',
    fontSize: 'typography.h6.fontSize',
  },
  body: {
    fontSize: 14,
  },
};

class GridHeaderCell extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      mode:0
    };
  }

  render(){
    const {classes} = this.props;
    return (
      <TableCell variant={"head"}  sx={{...s.headercell}}>
        {this.props.children}
      </TableCell>);
  }
}

export default GridHeaderCell;
